import { PublicSelectComponent } from '@componentes/public-select/public-select.component';
import { Component, forwardRef, OnInit } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { Select } from '@layout/interfaces/select';
import { PrevisaoTempoService } from '@home/submodulos/previsao-numerica-tempo/services/previsao-tempo.service';
import { format } from 'date-fns';
import ptBrLocale from 'date-fns/locale/pt-BR';

const FORMATACAO_TEMPO = "dd 'de' MMMM 'de' yyyy HH:mm OOOO";

@Component({
	selector: 'seira-public-select-execucao-de-tempo',
	templateUrl: './public-select.component.html',
	styleUrls: ['./public-select.component.scss'],
	providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			multi: true,
			useExisting: forwardRef(() => PublicSelectExecucaoDeTempoComponent),
		},
	],
})
export class PublicSelectExecucaoDeTempoComponent
	extends PublicSelectComponent<Select, string>
	implements OnInit
{
	override optionValue = 'value';
	override optionLabel = 'name';
	override carregando = true;
	override carregandoLabel = 'Carregando as execuções';
	override label = 'Execução';
	override placeholder = 'Informe o tempo de execução';

	constructor(private previsaoTempoService: PrevisaoTempoService) {
		super();
	}

	ngOnInit() {
		this.previsaoTempoService.listarExecucoes().subscribe(execucoes => {
			this.options = execucoes.map(({ dataExecucao }) => ({
				value: dataExecucao,
				name: `WRF - ${format(new Date(dataExecucao), FORMATACAO_TEMPO, {
					locale: ptBrLocale,
				})}`,
			}));
			this.value = this.options[0].value;
			this.onValueChange(this.value);
			this.carregando = false;
			this.carregandoChange.emit(this.carregando);
		});
	}
}
